import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '~/routes/query-params';

export const useGeographicDrawer = () => {
  const { deleteQueryParam, setQueryParams, params } = useQueryParams();

  const isDrawerOpen =
    params[queryKeys.activeDrawer] === queryValues.geographicExposureDrawer;
  const countryCode = params[queryKeys.countryCode];
  const regionName = params[queryKeys.regionName];

  const openCountry = (code: string) =>
    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.geographicExposureDrawer,
      [queryKeys.countryCode]: code,
      [queryKeys.regionName]: '',
    });

  const openRegion = (name: string) =>
    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.geographicExposureDrawer,
      [queryKeys.regionName]: name,
      [queryKeys.countryCode]: '',
    });

  const closeDrawer = () =>
    deleteQueryParam([
      queryKeys.activeDrawer,
      queryKeys.countryCode,
      queryKeys.regionName,
    ]);

  const type = regionName ? 'region' : countryCode ? 'country' : null;

  return {
    closeDrawer,
    openCountry,
    openRegion,
    isDrawerOpen,
    countryCode,
    regionName,
    type,
  };
};
